import { Component } from '@angular/core';

@Component({
  selector: 'app-arrows-swap',
  templateUrl: './arrows-swap.component.html',
  styleUrls: ['./arrows-swap.component.scss']
})
export class ArrowsSwapComponent {

}
